import GetIcon from "Components/Global/Icons";

import * as S from "./styles";

import { useTheme } from "styled-components";

const NotificationIcon = ({ icon, read }) => {
  const theme = useTheme();

  return (
    <S.Type read={read}>
      <GetIcon
        name={icon || "Bell"}
        color={read ? theme.colors.neutral.cinza600 : theme.colors.primary.blue}
      />
    </S.Type>
  );
};

export default NotificationIcon;
